import { useLocation } from "react-router-dom";
import "./style.css";

const PrivacyPage = () => {
	const location = useLocation();

	return (
		<div className="privacy-page" id="Privacy">
			<div className="container">
				<p className="title">
					{location?.pathname?.includes("terms")
						? "Terms & Conditions"
						: "Privacy Policy"}{" "}
				</p>

				<div class="section">
					<div class="section-title">1. Introduction</div>
					<ol>
						<li>
							We are committed to safeguarding the privacy of our platform
							users; in this policy we explain how we will treat your personal
							information.
						</li>
						<li>
							We will ask you to consent to our use of cookies in accordance
							with the terms of this policy when you first visit our platform.
							By using our platform and agreeing to this policy, you consent to
							our use of cookies in accordance with the terms of this policy.
						</li>
					</ol>
				</div>

				<div class="section">
					<div class="section-title">2. Collecting Personal Information</div>
					<ol>
						<li>
							We may collect, store and use the following kinds of personal
							information:
							<ol type="a">
								<li>
									Information about your computer and about your visits to and
									use of this platform including (your IP address, geographical
									location, browser type and version, operating system, referral
									source, length of visit, page views and platform navigation
									paths).
								</li>
								<li>
									Information that you provide to us when registering with our
									platform including your name, your email address, and your
									phone number.
								</li>
								<li>
									Information that you provide when completing your profile on
									our platform including (your name, profile pictures, gender,
									date of birth, interests).
								</li>
								<li>
									Information that you provide to us for the purpose of
									subscribing to our email notifications and/or WhatsApp
									notifications and/or newsletters (including your name, your
									email address and phone number).
								</li>
								<li>
									Information that you provide to us when using the services on
									our platform, or that is generated in the course of the use of
									those services including (the timing, frequency and pattern of
									service use).
								</li>
								<li>
									Information relating to any purchases you make or any other
									transactions that you enter into through our platform
									(including your name, address, telephone number, email address
									and card details).
								</li>
								<li>
									Information that you upload to our platform for publication.
								</li>
								<li>
									Information contained in or relating to any communication that
									you send to us.
								</li>
								<li>
									Any other personal information that you choose to send to us.
								</li>
							</ol>
						</li>
					</ol>
				</div>

				<div class="section">
					<div class="section-title">3. Using Personal Information</div>
					<ol>
						<li>
							Personal information submitted to us through our platform will be
							used for the purposes specified in this policy or on the relevant
							pages of the platform.
						</li>
						<li>
							We may use your personal information to:
							<ol type="a">
								<li>Manage our platform and business.</li>
								<li>Personalize our platform for you.</li>
								<li>
									Enable your use of the services available on our platform.
								</li>
								<li>Send you products purchased through our platform.</li>
								<li>
									Provide you with services purchased through our platform.
								</li>
								<li>
									Send statements, invoices and payment reminders to you, and
									collect payments from you.
								</li>
								<li>Send you non-marketing commercial communications.</li>
								<li>
									Send you email notifications that you have specifically
									requested.
								</li>
								<li>
									Send you our email newsletter, if you have requested it (you
									can inform us at any time if you no longer require the
									newsletter).
								</li>
								<li>
									Send you marketing communications relating to our business (or
									the business of carefully selected third parties) which we
									think may be of interest to you.
								</li>
								<li>
									Provide third parties with statistical information about our
									users.
								</li>
								<li>
									Deal with enquiries and complaints made by or about you
									relating to our platform.
								</li>
								<li>Keep our platform safe and secure.</li>
							</ol>
						</li>
						<li>
							Where you submit personal information for publication on our
							platform, we will publish and otherwise use that information in
							accordance with the license you grant to us.
						</li>
						<li>
							Your privacy settings can be used to limit the publication of your
							information on our platform, and thus to control the extent to
							which we will publish your information.
						</li>
						<li>
							We may disclose information about you to any member of our group
							of companies (this means our subsidiaries, our ultimate holding
							company and all its subsidiaries) insofar as reasonably necessary
							for the purposes set out in this policy.
						</li>
						<li>
							We may disclose your personal information:
							<ol type="a">
								<li>To the extent that we are required to do so by law.</li>
								<li>
									In connection with any legal proceedings or prospective legal
									proceedings relating to your use of our platform or this
									policy.
								</li>
								<li>
									In order to establish, exercise or defend our legal rights
									(including providing information to others for the purposes of
									fraud prevention and reducing credit risk).
								</li>
								<li>
									To any person who we reasonably believe may apply to a court
									or other competent authority for disclosure of that personal
									information, where in our reasonable opinion such court or
									authority would be likely to order disclosure of that personal
									information.
								</li>
							</ol>
						</li>
					</ol>
				</div>

				<div class="section">
					<div class="section-title">4. Disclosing Personal Information</div>
					<ol>
						<li>
							We may disclose your personal information to any of our employees,
							officers, insurance providers, professional advisers, agents,
							suppliers or subcontractors insofar as reasonably necessary for
							the purposes set out in this policy.
						</li>
						<li>
							We may disclose your personal information to any member of our
							group of companies (this means our subsidiaries, our ultimate
							holding company and all its subsidiaries) insofar as reasonably
							necessary for the purposes set out in this policy.
						</li>
						<li>
							We may disclose your personal information:
							<ol type="a">
								<li>To the extent that we are required to do so by law.</li>
								<li>
									In connection with any legal proceedings or prospective legal
									proceedings relating to your use of our platform or this
									policy.
								</li>
								<li>
									In order to establish, exercise or defend our legal rights
									(including providing information to others for the purposes of
									fraud prevention and reducing credit risk).
								</li>
							</ol>
						</li>
					</ol>
				</div>

				<div class="section">
					<div class="section-title">5. International Data Transfers</div>
					<ol>
						<li>
							Information that we collect may be stored, processed in, and
							transferred between, any of the countries in which we operate, to
							enable us to use the information in accordance with this policy.
						</li>
						<li>
							Personal information which you publish on our platform or submit
							for publication on our platform may be available, via the
							internet, around the world. We cannot prevent the use (or misuse)
							of such personal information by others.
						</li>
						<li>
							You expressly agree to such transfers of personal information as
							described in this section 5.
						</li>
					</ol>
				</div>

				<div class="section">
					<div class="section-title">6. Retaining Personal Information</div>
					<ol>
						<li>
							This section 6 sets out our data retention policies and
							procedures, which are designed to help ensure that we comply with
							our legal obligations in relation to the retention and deletion of
							personal information.
						</li>
						<li>
							Personal information that we process for any purpose or purposes
							shall not be kept for longer than is necessary for that purpose or
							those purposes.
						</li>
						<li>
							Notwithstanding the other provisions of this section 6, we will
							retain documents (including electronic documents) containing
							personal information:
							<ol type="a">
								<li>To the extent that we are required to do so by law.</li>
								<li>
									If we believe that the documents may be relevant to any
									ongoing or prospective legal proceedings.
								</li>
								<li>
									In order to establish, exercise or defend our legal rights
									(including providing information to others for the purposes of
									fraud prevention and reducing credit risk).
								</li>
							</ol>
						</li>
					</ol>
				</div>

				<div class="section">
					<div class="section-title">7. Security of Personal Information</div>
					<ol>
						<li>
							We will take reasonable technical and organizational precautions
							to prevent the loss, misuse or alteration of your personal
							information.
						</li>
						<li>
							We will store all the personal information you provide on our
							secure (password- and firewall-protected) servers.
						</li>
						<li>
							All electronic financial transactions entered into through our
							platform will be protected by encryption technology.
						</li>
						<li>
							You acknowledge that the transmission of information over the
							internet is inherently insecure, and we cannot guarantee the
							security of data sent over the internet.
						</li>
						<li>
							You are responsible for keeping the password you use for accessing
							our platform confidential; we will not ask you for your password
							(except when you log in to our platform).
						</li>
					</ol>
				</div>

				<div class="section">
					<div class="section-title">8. Amendments</div>
					<ol>
						<li>
							We may update this policy from time to time by publishing a new
							version on our platform.
						</li>
						<li>
							You should check this page occasionally to ensure you are happy
							with any changes to this policy.
						</li>
						<li>
							We may notify you of changes to this policy (by email or through
							the private messaging system on our platform).
						</li>
					</ol>
				</div>

				<div class="section">
					<div class="section-title">9. Your Rights</div>
					<ol>
						<li>
							You may instruct us to provide you with any personal information
							we hold about you.
						</li>
						<li>
							You may access, update, and delete the personal information you
							provide in your account as you require.
						</li>
						<li>
							We may withhold personal information that you request to the
							extent permitted by law.
						</li>
						<li>
							You may instruct us at any time not to process your personal
							information for marketing purposes.
						</li>
						<li>
							In practice, you will usually expressly agree in advance to our
							use of your personal information for marketing purposes.
						</li>
					</ol>
				</div>

				<div class="section">
					<div class="section-title">10. Third Party Platforms</div>
					<ol>
						<li>
							Our platform includes hyperlinks to, and details of, third party
							platforms.
						</li>
						<li>
							We have no control over, and are not responsible for, the privacy
							policies and practices of third parties.
						</li>
					</ol>
				</div>

				<div class="section">
					<div class="section-title">11. Updating Information</div>
					<ol>
						<li>
							Please let us know if the personal information that we hold about
							you needs to be corrected or updated.
						</li>
					</ol>
				</div>

				<div class="section">
					<div class="section-title">12. Our Details</div>
					<ol>
						<li>
							This platform is owned and operated by YUSUR Product Promotion
							Company O.P.C
						</li>
						<li>
							We are registered in Kuwait under registration number 2025/15856
							and located in Kuwait, Alardiya, block 10.
						</li>
						<li>
							You can contact us by writing to the business address given above,
							or by email to yusurapplication@gmail.com, or by telephone on
							56613815
						</li>
					</ol>
				</div>
			</div>
		</div>
	);
};
export default PrivacyPage;
